module.exports = __webpack_public_path__ + "static/media/spade.aa7f0bfb.svg";